module.exports = __webpack_public_path__ + "img/image-footer-2.34d989be.png";